var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelButtonClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel_19px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 19,
    height: 19,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M127.168,125.728,131.2,121.7a1.019,1.019,0,1,0-1.439-1.442l-4.029,4.029-4.029-4.029a1.02,1.02,0,1,0-1.442,1.442l4.029,4.029-4.029,4.029A1.02,1.02,0,1,0,121.7,131.2l4.029-4.029,4.029,4.029a1.02,1.02,0,1,0,1.442-1.442Z",
    transform: "translate(-116.228 -116.228)",
    fill: "#969fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButtonClearIcon);
export default __webpack_public_path__ + "static/media/cancel-button-clear-icon.9fde0cf6f2d31332e2900c6c7c731f7e.svg";
export { ForwardRef as ReactComponent };